import gql from 'graphql-tag'

const COMMON_TAGS = {
  VIEWER: gql`
    query ViewerV1 {
      viewer {
        user {
          phone
          activity {
            __typename
          }
          authIdHash
          email
          id
          image {
            url
          }
          name
          phone
          sberLoyalty {
            __typename
          }
          sberPrime {
            __typename
          }
          sberUuid
        }
      }
    }
  `,

  QUICK_SEARCH: gql`
    query SearchV3($text: String!, $query: String!, $offset: Int, $first: Int) {
      search_v2(searchText: $text, query: $query, offset: $offset, first: $first) {
        items {
          __typename
          ... on Place {
            ...PlaceSearchItem
          }
          ... on Article {
            ...ArticleSearchItem
          }
        }
      }
    }

    fragment PlaceSearchItem on Place {
      __typename
      id
      url
      name
      afishaChoice
      address
      city {
        id
        name
      }
      features {
        __typename
        ... on RestaurantFeatures {
          reservationUrl
        }
      }
    }

    fragment ArticleSearchItem on Article {
      __typename
      id
      name
      url
      publicationDate
    }
  `,

  FAVORITES: gql`
    query FavoritesV3($id: ID!, $first: Int!) {
      user(id: $id) {
        activity {
          favorites(first: $first) {
            totalCount

            items {
              subject {
                ... on Place {
                  __typename
                  id
                  name
                }

                ... on Concert {
                  __typename
                  id
                  name
                }

                ... on Person {
                  __typename
                  id
                  name
                }

                ... on Article {
                  __typename
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  `,

  ADD_FAVORITE: gql`
    mutation AddFavoriteV3($input: AddFavoriteInput!) {
      addFavorite(input: $input) {
        clientMutationId
      }
    }
  `,

  DELETE_FAVORITE: gql`
    mutation DeleteFavoriteV3($input: DeleteFavoriteInput!) {
      deleteFavorite(input: $input) {
        clientMutationId
      }
    }
  `,

  DAILY: gql`
    query GetDaily {
      recentArticles(filter: { rubric: ["Еда"], theme: ["Рестораны"], limit: 20 }) {
        ... on Entry {
          id
          title
          slug
          photoModifications {
            crop {
              size {
                height
                width
              }
            }
            photoPath
            place
          }
          rubric {
            slug
          }
        }
      }
    }
  `,
}

const CONCERTS_TAGS = {
  // Запрос на проверку будет ли хоть какое нибудь мероприятие в этом ресторане
  CONCERT_CALENDAR: gql`
    query CalendarV3($restId: ID!) {
      place(id: $restId) {
        name
        scheduleMeta {
          any
          concert
          exhibition
          movie
          performance
          sport
        }
      }
    }
  `,

  // Запрос на проверку доступных дат в календаре
  CONCERT_CALENDAR_DAYS_AVAILABLE: gql`
    query CalendarAvailableV3($restId: ID!, $offset: Int!, $first: Int!, $query: String!) {
      place(id: $restId) {
        scheduleConcerts(offset: $offset, first: $first, query: $query) {
          filters {
            ... on DateRangeFilter {
              __typename
              availableDays {
                value
              }
            }
          }
          items {
            sessions {
              dateTime
            }
          }
        }

        scheduleExhibitions(offset: $offset, first: $first, query: $query) {
          filters {
            ... on DateRangeFilter {
              __typename
              availableDays {
                value
              }
            }
          }
          items {
            sessions {
              dateTime
            }
          }
        }

        scheduleMovies(offset: $offset, first: $first, query: $query) {
          filters {
            ... on DateRangeFilter {
              __typename
              availableDays {
                value
              }
            }
          }
          items {
            sessions {
              dateTime
            }
          }
        }

        schedulePerformances(offset: $offset, first: $first, query: $query) {
          filters {
            ... on DateRangeFilter {
              __typename
              availableDays {
                value
              }
            }
          }
          items {
            sessions {
              dateTime
            }
          }
        }

        scheduleSports(offset: $offset, first: $first, query: $query) {
          filters {
            ... on DateRangeFilter {
              __typename
              availableDays {
                value
              }
            }
          }
          items {
            sessions {
              dateTime
            }
          }
        }
      }
    }
  `,

  // Запрос событий по ресторану на конкретные дни с информацией о концерте и разных сессиях
  CONCERT_PAYMENTS_LIST: gql`
    query PaymentsListV3($restId: ID!, $offset: Int!, $first: Int!, $query: String!) {
      place(id: $restId) {
        scheduleConcerts(offset: $offset, first: $first, query: $query) {
          filters {
            ... on DateRangeFilter {
              name
              title
              availableDays {
                value
              }
            }
          }
          totalCount
          items {
            concert {
              id
              name
              afishaChoice
              url
              image {
                url
              }
              genres {
                name
              }
            }
            sessions {
              dateTime
              sessionSourceID
              minPrice
            }
          }
        }

        scheduleExhibitions(offset: $offset, first: $first, query: $query) {
          filters {
            ... on DateRangeFilter {
              name
              title
              availableDays {
                value
              }
            }
          }
          totalCount
          items {
            exhibition {
              id
              name
              afishaChoice
              url
              image {
                url
              }
              genres {
                name
              }
            }
            sessions {
              dateTime
              sessionSourceID
              minPrice
            }
          }
        }

        scheduleMovies(offset: $offset, first: $first, query: $query) {
          filters {
            ... on DateRangeFilter {
              name
              title
              availableDays {
                value
              }
            }
          }
          totalCount
          items {
            movie {
              id
              name
              afishaChoice
              url
              image {
                url
              }
              genres {
                name
              }
            }
            sessions {
              dateTime
              sessionSourceID
              minPrice
            }
          }
        }

        schedulePerformances(offset: $offset, first: $first, query: $query) {
          filters {
            ... on DateRangeFilter {
              name
              title
              availableDays {
                value
              }
            }
          }
          totalCount
          items {
            performance {
              id
              name
              afishaChoice
              url
              image {
                url
              }
              genres {
                name
              }
            }
            sessions {
              dateTime
              sessionSourceID
              minPrice
            }
          }
        }

        scheduleSports(offset: $offset, first: $first, query: $query) {
          filters {
            ... on DateRangeFilter {
              name
              title
              availableDays {
                value
              }
            }
          }
          totalCount
          items {
            sport {
              id
              name
              afishaChoice
              url
              image {
                url
              }
              genres {
                name
              }
            }
            sessions {
              dateTime
              sessionSourceID
              minPrice
            }
          }
        }
      }
    }
  `,
}

export const GQL_TAGS = Object.assign({}, COMMON_TAGS, CONCERTS_TAGS)

type TypeArgsHandleFavorite = { subjectId: number; subjectTypeName: 'Restaurant' | 'Selection' | 'Article' | 'Concert' }
